import { Stack } from '@mui/material';
import React from 'react';
import ContentManagementInterface from '../../models/ContentManagementInterface';
import { Palette } from 'Palette';
import { StyledCard, StyledCardContent, StyledTypography } from '../styles/styles';
import ImageCarousel from '../template/ImageCarousel';
import LeftRightList from '../template/LeftRightList';
import StandardHeaderText from '../template/StandardHeaderText';
import Subtitle from '../template/Subtitle';
import Table from '../template/Table';
import TextBlock from '../template/TextBlock';
import HeroImage from '../template/HeroImage';

type ContentTone = 'default' | 'tone1' | 'tone2' | 'tone3';

interface ContentVersionReadOnlyProps {
  content: ContentManagementInterface | null;
  tone: keyof typeof Palette;
}

const ContentVersionReadOnly: React.FC<ContentVersionReadOnlyProps> = ({ content, tone }) => {
  if (!content || !content.content) {
    return (
      <StyledTypography tone={tone} color="text.secondary">
        No content data available
      </StyledTypography>
    );
  }

  const contentTone = tone as ContentTone;

  return (
    <Stack spacing={2}>
      {content.content.map((item, index) => {
        const key = `${item.type}-${item.id || index}`;

        switch (item.type) {
          case 'StandardHeaderText':
            return (
              <StandardHeaderText
                key={key}
                heading={item.properties.heading}
                content={item.properties.content}
                id={item.properties.id}
                tone={contentTone}
                editMode={false}
                footnotes={item.properties.footnotes || []}
              />
            );
          case 'Subtitle':
            return <Subtitle key={key} id={item.id} {...item.properties} tone={contentTone} />;
          case 'Text':
            return <TextBlock key={key} id={item.id} {...item.properties} tone={contentTone} />;
          case 'HeroImage':
            return <HeroImage key={key} id={item.id} {...item.properties} tone={contentTone} />;
          case 'ImageCarousel':
            return (
              <ImageCarousel
                key={key}
                {...item.properties}
                tone={contentTone}
                editMode={false}
                modelType="FundOpportunity"
                modelId=""
                footnotes={item.properties.footnotes || []}
              />
            );
          case 'LeftRightList':
            return (
              <LeftRightList
                key={key}
                {...{
                  ...item.properties,
                  editMode: false,
                }}
                tone={contentTone}
                footnotes={item.properties.footnotes || []}
              />
            );
          case 'Table':
            return (
              <Table
                key={key}
                {...{
                  ...item.properties,
                  editMode: false,
                }}
                tone={contentTone}
                footnotes={item.properties.footnotes || []}
              />
            );
          default:
            return (
              <StyledCard key={key} tone={tone}>
                <StyledCardContent>
                  <StyledTypography color="text.secondary">
                    Unknown content type: {item.type}
                  </StyledTypography>
                </StyledCardContent>
              </StyledCard>
            );
        }
      })}
    </Stack>
  );
};

export default ContentVersionReadOnly;
